var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "modal-fade" }, [
    _c("div", { staticClass: "modal", style: `max-width:${_vm.width}px` }, [
      !_vm.hideCloseButton
        ? _c(
            "button",
            { staticClass: "modal-close", on: { click: _vm.modalClose } },
            [
              _c(
                "svg",
                {
                  attrs: {
                    width: "18",
                    height: "18",
                    viewBox: "0 0 23 23",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M2.00342 2L20.6685 20.6651",
                      stroke: "black",
                      "stroke-width": "3",
                      "stroke-linecap": "round",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M20.665 2L1.99993 20.6651",
                      stroke: "black",
                      "stroke-width": "3",
                      "stroke-linecap": "round",
                    },
                  }),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "modal-content" }, [_vm._t("default")], 2),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }